<template>
  <div class="train-knowledge-container center-setting">
    <TitleCard class="train-knowledge-produce-wrap"
               title="培训视频列表"
               :loading="loading"
               :isEmpty="emptyOpt.isEmpty"
               :showMore="false"
               type='line-name-line'>
      <a-row class="row-item"
             :gutter="16">
        <a-col v-for="item in resultList"
               :key="item.id"
               :span="6">
          <div class="video-item"
               @click="playVideo(item)">
            <MediaWrap :height="150"
                       :url="item.fileVo && item.fileVo.filePath"></MediaWrap>
            <div class="content-describe-wrap">
              <div class="name"
                   :title="item.name">{{item.name}}</div>
              <div class="detail"
                   :title="item.content">{{item.content}}</div>
            </div>
          </div>
        </a-col>
      </a-row>
    </TitleCard>
    <Pagination ref="pagination"
                :pageSize="8"
                :defaultPageSize="8"
                :total="total"
                @pageChange="handleChange"></Pagination>
    <VideoPlay ref="video"
               :videoUrl="url"
               @cancelPlay="cancelPlay"
               :loading="loadingVideo"></VideoPlay>
  </div>

</template>

<script>
import { getVideoList, getVideoInfoDetail } from '@/api/MTrainVideo.js'
// 测试
import Pagination from '@/components/common/Pagination'
import VideoPlay from '@/components/videoplayer/videoplayer'
import { mapGetters } from 'vuex'
// import { canPlayVideo } from '@/utils/userAuthorizeList'

export default {
  data() {
    return {
      loading: false,
      loadingVideo: false, // 加载视频
      resultList: [],
      emptyOpt: {
        isEmpty: false,
      },
      total: 0, // 数据的总数
      url: '', // 播放视频的路径
      searchParams: {
        pageSize: 8,
        pageNum: 1,
      },
    }
  },
  components: {
    Pagination,
    VideoPlay,
  },
  computed: {
    ...mapGetters('user', ['account']),
  },
  mounted() {
    this.loadData()
  },
  methods: {
    beforeRequestParams() {
      const { currentPagination: pageNum, pageSize } = this.$refs.pagination
      return {
        pageSize,
        pageNum,
      }
    },
    // 设置默认的图片
    handlerInitPicture(rows) {
      rows.forEach((item) => {
        if (!item.fileVo) {
          item.fileVo = { filePath: '/static/wuxi/video_empty_bg.png' }
        }
      })
    },
    // 加载数据
    async loadData() {
      try {
        this.loading = true
        const params = this.beforeRequestParams() // 请求前的参数处理
        const { rows, total } = await getVideoList(params)
        this.handlerInitPicture(rows) // 没有图片使用默认的系统图片
        this.total = total
        this.emptyOpt.isEmpty = rows.length === 0
        this.resultList = rows
      } catch (error) {
        this.$apiStatusHandler(99, error.message)
      } finally {
        this.loading = false
      }
    },
    // 跳转详情
    toDetail(uid) {
      this.$router.push({ name: 'talentDetail', query: { uid } })
    },
    getUrl(item) {
      if (item.fileVo.length > 0) {
        return item.fileVo[0].filePath
      } else {
        return ''
      }
    },
    // 处理分页器变化
    handleChange() {
      // this.searchParams.pageNum = pageNum
      this.loadData()
    },
    async playVideo(instance) {
      // 中山项目不需要登录也能看视频
      if ((this.account === '游客' || this.account === '') && process.env.VUE_APP_KEY !== 'zhongshan') {
        return this.$apiStatusHandler(20, '请登录观看视频资源')
      }
      try {
        this.loadingVideo = true
        const { code, data } = await getVideoInfoDetail(instance.id)
        if (code === 200) {
          this.$refs.video.showModal()
          if (data.fileUploadVo) {
            this.url = data.fileUploadVo.fileUrl
          }
        }
      } catch (error) {
        this.$apiStatusHandler(99, error.message)
      } finally {
        this.loadingVideo = false
      }
    },
    // 取消播放
    cancelPlay() {
      this.url = ''
      this.loadingVideo = false
    },
  },
}
</script>
